import { TrackingSystemParameters } from '@poseidon/tracklib/lib/tracklib.systems'
import * as Sentry from '@sentry/browser'
import { userData } from '../service/config'
import { tracklib } from '../service/tracker'

export function getSourceUrl(source: string): string {
  const helper = document.createElement('a');
  helper.href = source;
  const newUrl = new URL(helper.href);
  return newUrl.toString();
}

export function trackStartup(): void {
  const startupData: TrackingSystemParameters = {
    section: 'startup',
    trackingtype: 'ev',
    contentposition: userData.activeTheme,
  };

  const result = document.cookie.split(';')
    .map((val) => val.trim().split('='))
    .filter(([key]) => key === 'detectionResult')
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    .map(([key, val]) => val)[0];

  /* istanbul ignore next else */
  if (result) {
    startupData.result = result;
  }

  tracklib.track(startupData);
}

export function getPerformanceNavigationTiming(): PerformanceNavigationTiming {
  /* istanbul ignore next else */
  if (window.performance && typeof window.performance.getEntriesByType === 'function') {
    const entries = window.performance.getEntriesByType('navigation') as unknown as PerformanceNavigationTiming[];
    /* istanbul ignore next else */
    if (entries && entries.length > 0) {
      return entries[entries.length -1];
    }
  }
  /* istanbul ignore next */
  return null;
}

export function setSentryPerformanceData(): void {
  const perfData = getPerformanceNavigationTiming();
  /* istanbul ignore next else */
  if (perfData) {
    Sentry.setContext('performanceNavigationTiming', {
      domComplete: perfData.domComplete,
      domInteractive: perfData.domInteractive,
      redirectCount: perfData.redirectCount,
      type: perfData.type
    });
  }
}

export function getUrlParam(param: string): string {
  const params = new URLSearchParams(location.search);
  return params.get(param);
}

/**
 * Returns a promise that resolves after the given amount of time (in ms)
 * @param timeout
 */
export function timeoutPromise(timeout: number): Promise<void> {
  return new Promise<void>((resolve) => {
    window.setTimeout(() => {
      resolve()
    }, timeout)
  })
}
